module.exports = __webpack_public_path__ + "img/marketing-4-collaboration.3139383c.svg";